<template>
    <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
      <div class="table__search-input-wrapper w-[350px] filter-search">
        <span class="pr-2 opacity-50"><search-icon /> </span>
  
        <input type="text" class="table__search-input" placeholder="Search..." />
      </div>
      
      <div id="scroller">
      
      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">ConsolidationID</span></label>
        <el-select filterable v-model="consolidationId" placeholder="All"
         @change="handleSelectChange('consolidationId')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation.consolidationReference"
            :value="consolidation.consolidationReference"
            >
          </el-option>
        </el-select>
      </div>  

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Shipment Count</span></label>
        <el-select filterable v-model="shipmentCount" placeholder="All"
         @change="handleSelectChange('shipmentCount')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation?.shippings?.length"
            :value="consolidation?.shippings?.length"
            >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">ORIGIN</span></label>
        <el-select filterable v-model="origin" placeholder="All"
         @change="handleSelectChange('origin')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation.originationTerminal.state"
            :value="consolidation.originationTerminal.state"
            >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">DESTINATION</span></label>
        <el-select filterable v-model="destination" placeholder="All"
         @change="handleSelectChange('destination')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation.destinationTerminal.state"
            :value="consolidation.destinationTerminal.state"
            >
          </el-option>
        </el-select>
      </div>

      <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Fleet</span></label>
        <el-select filterable v-model="fleet" placeholder="All"
         @change="handleSelectChange('fleet')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation?.fleet?.equipment"
            :value="consolidation?.fleet?.equipment"
            >
          </el-option>
        </el-select>
      </div>

       <div class="individual-contaoner">
        <label class="label">FILTER BY: <span class="text-sm text-primary-yellow">Driver</span></label>
        <el-select filterable v-model="driver" placeholder="All"
         @change="handleSelectChange('driver')">
          <el-option  v-for="consolidation in consolidations" :key="consolidation.id" :label="consolidation.consolidationReference"
            :value="consolidation.consolidationReference"
            >
          </el-option>
        </el-select>
      </div>

    </div>
        <div class="flex items-center cursor-pointer mt-5">
        <div  @click="apply">
          <primary-button buttonText="Apply" :loading="loading" />
        </div>
        <div>
          <p @click="closeModal()" class="pl-3">Cancel</p>
        </div>
  
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
      // bookings: {
      //   required: true,
      // },
      consolidations: {
        type: Array,
        required: true,
      },
    },
  
    data() {
      return {
        // selectedField: null,
        loading: false,
        // fleets: [],
        // routes: [],
        // filter: {
          equipment: null,
          consolidationId: null,
          // date: "",
          // bookingChannel: "",
          // origin: "",
          // destination: "",
          // sender: null,
          // receiver: null,
          // route: ""
        // },
      };
    },
  
    methods: {
      apply() {
        const equipment = this.consolidationId
        this.$emit("appliedRef", equipment)
      //   if (this.selectedField === 'sender') {
      //     const sender = this.sender
      //     this.$emit("appliedRef", sender)
      //   }else if(this.selectedField === 'receiver') {
      //     const receiver = this.receiver
      //     this.$emit("appliedRef", receiver)
      //   }else if(this.selectedField === 'shippingID'){
      //     const shippingID = this.shippingID
      //     this.$emit("appliedRef", shippingID)
      //   }
       
        this.closeModal()
      },
  
      closeModal() {
        this.$emit("close-modal");
      }, 
      
      // handleSelectChange(field) {
      //   // Set the selected field when an option is chosen
      //   if (this[field]) {
      //     this.selectedField = field;
      //   } else {
      //     this.selectedField = null;
      //   }
      // },
  
      // isDisabled(field) {
      //   // Disable all other select fields if one is selected
      //   return this.selectedField && this.selectedField !== field;
      // },
  
    },
  };
  </script>
  
  <style scoped lang="scss">
    #scroller {
  max-height: 300px;
  overflow-y: auto;
}
  .label {
    @apply border-b-2 border-gray-400 w-full pb-1;
    font-size: 13px;
  }
  
  .individual-contaoner {
    @apply w-full border-2 border-gray-300 border-dashed p-2 my-3
  }
  
  .filter-search {
    border-radius: 4px;
    @apply py-2
  }
  </style>
  